import { cn } from '@/lib/utils';
import { X } from 'lucide-react';

export function Dialog({ open, onOpenChange, children }: { 
  open: boolean; 
  onOpenChange: (v: boolean) => void; 
  children?: React.ReactNode 
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => onOpenChange(false)}>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full p-6" onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}

export function DialogContent({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <div className={cn('', className)}>{children}</div>;
}

export function DialogHeader({ children }: { children?: React.ReactNode }) {
  return <div className="mb-4">{children}</div>;
}

export function DialogTitle({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <h2 className={cn('text-xl font-bold', className)}>{children}</h2>;
}

export function DialogDescription({ children }: { children?: React.ReactNode }) {
  return <p className="text-sm text-gray-500 dark:text-gray-400">{children}</p>;
}

export function DialogFooter({ children, className = '' }: { children?: React.ReactNode; className?: string }) {
  return <div className={cn('flex justify-end gap-2 mt-6', className)}>{children}</div>;
}
